import * as React from "react";
import { TestResults } from "../Shared/PFTAPITypes";
import { ResultsGroupHeading } from "../Shared/ResultsGroupHeading";

export interface SvcTestAcceptabilityTableProps {
    displayTechnicianAcceptability: boolean;
    isViewOnly: boolean;
    isLoading: boolean;
    testResults: Array<TestResults>;
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
}

export const SvcTestAcceptabilityTable = ({ displayTechnicianAcceptability, isViewOnly, isLoading, testResults, onAcceptabilityChange }: SvcTestAcceptabilityTableProps) => {
    return (
        <>
            <ResultsGroupHeading resultsCount={testResults.length} title="Acceptability" />
            <tr>
                <td>Acceptable</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`OverreaderAcceptability${tr.TestId}`}>
                                <input
                                    data-automationid={`OverreaderAcceptability-${tr.TestNumber}`}
                                    disabled={isViewOnly}
                                    checked={tr.OverreaderAcceptability}
                                    type="checkbox"
                                    onChange={(e) => onAcceptabilityChange(tr.TestId, e.target.checked)}
                                />
                            </td>
                        );
                    })
                }
                <td></td>
            </tr>
            {displayTechnicianAcceptability ? <tr>
                <td>Technician Acceptability</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`TechnicianAcceptability${tr.TestId}`}>
                                <input
                                    data-automationid={`TechnicianAcceptability-${tr.TestNumber}`}
                                    disabled={true}
                                    readOnly={true}
                                    checked={tr.TechnicianAcceptability}
                                    type="checkbox"
                                />
                            </td>
                        );
                    })
                }
                <td></td>
            </tr> : null}

        </>
    );
}
